import { createSelector } from 'reselect';

const selecttenantDomains = (state: any) => state.tenantDomains;


export const selecttenantDomainsCurrentItem = createSelector([selecttenantDomains], (tenantDomains) => tenantDomains.current);

export const selecttenantDomainsListItems = createSelector([selecttenantDomains], (tenantDomains) => tenantDomains.list);

export const selectItemById = (itemId: any) =>
    createSelector(selecttenantDomainsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selecttenantDomainsQueryItems = createSelector([selecttenantDomains], (tenantDomains) => tenantDomains.query);

export const selecttenantDomainsCreatedItem = createSelector([selecttenantDomains], (tenantDomains) => tenantDomains.create);

export const selecttenantDomainsUpdatedItem = createSelector([selecttenantDomains], (tenantDomains) => tenantDomains.update);

export const selecttenantDomainsReadItem = createSelector([selecttenantDomains], (tenantDomains) => tenantDomains.read);

export const selecttenantDomainsDeletedItem = createSelector([selecttenantDomains], (tenantDomains) => tenantDomains.delete);

export const selecttenantDomainsSearchedItems = createSelector([selecttenantDomains], (tenantDomains) => tenantDomains.search);

export const selecttenantDomainsItemsCount = createSelector([selecttenantDomains], (tenantDomains) => tenantDomains.count);

export const selecttenantDomainsItemsFilter = createSelector([selecttenantDomains], (tenantDomains) => tenantDomains.filter);